import { Button, Table, Input } from 'reactstrap';
import { Tbody, Thead } from 'react-super-responsive-table';
import * as mode from "../../../../../routes/PageMode";
import { CInput, decimalRegx_3dit } from '../../../../../CustomValidateForm';
import { IsSweetAndSnacksCompany } from './../../../../../components/Common/CommonFunction';

function BOMTable(props) {
  const isSweetAndSnacks = IsSweetAndSnacksCompany();
  const onDeleteHandeler = (ele) => {
    if (!(ele === 0)) {
      const filtered = props.tableData.filter((i) => i.id !== ele.id);
      props.func(filtered);
    }
  };

  const handleChange = (event, info) => {
    const val = event.target.value;
    const isValid = /^-?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)$/.test(val);

    if (isValid || val === "") {
      info.Quantity = val;
    } else {
      event.target.value = info.Quantity;
    }
  };

  const tableRows = props.tableData.map((info, key) => {
    return (
      <tr key={info.id || key}>
        {isSweetAndSnacks && (
          <td className="text-center">
            <Input
              type="checkbox"
              checked={!!info.IsReprocess}
              onChange={(e) => {
                const updatedData = props.tableData.map((row) => {
                  if (row.id === info.id) {
                    return { ...row, IsReprocess: e.target.checked ? 1 : 0 };
                  }
                  return row;
                });
                props.func(updatedData);
              }}
              disabled={props.pageMode === mode.view}
              style={{
                width: '15px',
                height: '15px',
                display: 'block',
                marginLeft: '0',
                marginRight: 'auto'
              }}
            />
          </td>
        )}
        <td>{info.ItemName}</td>
        <td>
          <div className='text-center' style={{ width: "150px" }}>
            <CInput
              type="text"
              key={info.id}
              style={{ width: '140px', textAlign: 'center' }}
              disabled={props.pageMode === mode.view}
              className="text-end"
              defaultValue={info.Quantity}
              onChange={(event) => handleChange(event, info)}
              cpattern={decimalRegx_3dit}
            />
          </div>
        </td>
        <td>{info.UnitName}</td>
        <td>
          <Button
            className="badge badge-soft-danger font-size-12 btn btn-danger waves-effect waves-light w-xxs border border-light"
            data-mdb-toggle="tooltip"
            data-mdb-placement="top"
            title="Delete Item"
            disabled={props.pageMode === mode.view}
            onClick={() => onDeleteHandeler(info)}
          >
            <i className="mdi mdi-delete font-size-18"></i>
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <>
      <div>
        <Table className="table table-bordered table-hover mb-2">
          <Thead>
            <tr>
              {isSweetAndSnacks && <th className='col col-sm-1'>IsReprocess</th>}
              <th className="col col-sm-3">Item</th>
              <th className="col col-sm-3">Quantity</th>
              <th className="col col-sm-3">Unit</th>
              <th className="col col-sm-3">Action</th>
            </tr>
          </Thead>
          <Tbody>{tableRows}</Tbody>

          {props.tableData.length === 0 && (
            <tr className="text-danger text-center mt-4">
              <td colSpan="5">Items Not Available</td>
            </tr>
          )}
        </Table>
      </div>
    </>
  );
}

export default BOMTable;
